import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class EditionApiModel extends AbstractDictionaryApiModel {
  @Expose() yearFrom: string;
  @Expose() yearTo: string;
  @Expose() fullName: string;
  @Expose() year: string;
}
